import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import Select from "react-select";
import { useGetTermListQuery } from "@/redux/termApi";
import { useGetMyRentCorpQuery } from "@/redux/rentCorpApi";
import { skipToken } from "@reduxjs/toolkit/query";

export const TermListPopup = ({ layer = true, onClose, formData, setFormData, handleChange, onTermsSelect }) => {
    const [query, setQuery] = useState("");
    const [selectedTerms, setSelectedTerms] = useState([]);
    const [rentCorpId, setRentCorpId] = useState(null);
    const [selectAll, setSelectAll] = useState(false);

    useEffect(() => {
        if (formData.contractTerms && formData.contractTerms.length > 0) {
            setSelectedTerms(
                formData.contractTerms.map((term) => ({
                    id: term.termId,
                    name: term.name,
                }))
            );
            // 데이터가 로드된 후에 전체 선택 상태 확인
            if (data?.data && formData.contractTerms.length === data?.data.length) {
                setSelectAll(true);
            }
        }
    }, [formData.contractTerms]);

    useEffect(() => {
        if (formData.contracts && formData.contracts[0]?.rentCorpId) {
            setRentCorpId(formData.contracts[0].rentCorpId);
        }
    }, [formData.contracts]);

    const { data: myRentCorpData } = useGetMyRentCorpQuery();
    const corpOptions =
        myRentCorpData && myRentCorpData.data
            ? myRentCorpData.data.map((item) => ({
                  value: item.id,
                  label: item.corpName,
              }))
            : [];

    const {
        data,
        isLoading: isLoadingTerm,
        error: errorTerm,
    } = useGetTermListQuery(rentCorpId ? { rent_corp_id: rentCorpId } : skipToken, { refetchOnMountOrArgChange: true, skip: !rentCorpId });

    const handleSelectAll = (checked) => {
        setSelectAll(checked);
        if (checked && data?.data) {
            setSelectedTerms(data.data);
        } else {
            setSelectedTerms([]);
        }
    };

    const handleConfirm = () => {
        // if (selectedTerms.length === 0) {
        //     setFormData((prev) => ({
        //         ...prev,
        //         toastMsg: "약관을 선택하세요.",
        //     }));
        //     return;
        // }
        const selectedTermsData = selectedTerms.map((item) => ({
            termId: item.id,
            name: item.name,
        }));
        onTermsSelect(selectedTermsData);
        onClose();
    };

    useEffect(() => {
        document.body.classList.add("scroll-lock");
        return () => {
            document.body.classList.remove("scroll-lock");
        };
    }, []);

    return ReactDOM.createPortal(
        <>
            <div className={layer ? "layer active" : "layer"} onClick={onClose}></div>
            <div className="popup vehicle-list-popup">
                <div className="popup-head">
                    <div className="head-tit">
                        <span className="tit-main">약관 선택</span>
                    </div>
                    <div className="btn-close" onClick={onClose}></div>
                </div>
                <div className="popup-content">
                    <div className="table-container">
                        <div className="table-filter">
                            <div className="filter-row">
                                <div className="filter-item">
                                    <div className="item-content">
                                        <div className="item-input">
                                            <Select
                                                options={corpOptions}
                                                className="custom-select"
                                                classNamePrefix="custom-select"
                                                isSearchable={false}
                                                placeholder="사업자 선택"
                                                value={corpOptions.find((opt) => opt.value === rentCorpId)}
                                                onChange={(option) => setRentCorpId(option.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="table-content">
                            <div className="table-wrapper">
                                <div className="table">
                                    <table>
                                        <colgroup>
                                            <col width="10%" />
                                            <col width="20%" />
                                            <col width="25%" />
                                            <col width="15%" />
                                            <col width="15%" />
                                            <col width="15%" />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>
                                                    <div className="cell">
                                                        <div className="input-checkbox">
                                                            <div className="checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    id={`selectedTerm-all`}
                                                                    checked={selectAll}
                                                                    onChange={(e) => handleSelectAll(e.target.checked)}
                                                                />
                                                                <label htmlFor={`selectedTerm-all`}></label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">사업자명</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">약관 명칭</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">적용 계약유형</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">필수/선택</span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <span className="cell-tit">활성/비활성</span>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data && data.data && data.data.length > 0 ? (
                                                data.data.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <div className="cell" style={{ height: "100%" }}>
                                                                <div className="input-checkbox">
                                                                    <div className="checkbox" style={{ display: "flex" }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            name="selectedTerm"
                                                                            id={`selectedTerm-${item.id}`}
                                                                            checked={selectedTerms.some((term) => term.id === item.id)}
                                                                            onChange={(e) => {
                                                                                if (e.target.checked) {
                                                                                    setSelectedTerms((prev) => [...prev, item]);
                                                                                    if (data.data.length === selectedTerms.length + 1) {
                                                                                        setSelectAll(true);
                                                                                    }
                                                                                } else {
                                                                                    setSelectedTerms((prev) =>
                                                                                        prev.filter((term) => term.id !== item.id)
                                                                                    );
                                                                                    setSelectAll(false);
                                                                                }
                                                                            }}
                                                                        />
                                                                        <label htmlFor={`selectedTerm-${item.id}`}></label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell" data-align="center">
                                                                <span className="cell-desc">{item.rentCorp.corpName}</span>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell" data-align="center">
                                                                <span className="cell-link">{item.name}</span>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell" data-align="center">
                                                                <span className="cell-desc">{item.phone}</span>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell" data-align="center">
                                                                <span className="cell-desc">
                                                                    {item.mandatoryYn === "Y" ? "필수" : "선택"}
                                                                </span>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="cell" data-align="center">
                                                                <span className="cell-desc">
                                                                    {item.exposedYn === "Y" ? "활성" : "비활성"}
                                                                </span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="6" className="data-empty">
                                                        <div className="cell" data-align="center">
                                                            <span className="cell-desc">데이터가 없습니다.</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="popup-bottom">
                    <button type="button" className="btn btn-primary btn-cancel" onClick={onClose}>
                        취소
                    </button>
                    <button type="button" className="btn btn-primary btn-confirm" onClick={handleConfirm}>
                        완료
                    </button>
                </div>
            </div>
        </>,
        document.body
    );
};
